module.exports = __webpack_public_path__ + "img/attraction1.18660c4e.jpg";